import { render, staticRenderFns } from "./cockpit.vue?vue&type=template&id=53d443bb"
import script from "./cockpit.vue?vue&type=script&lang=js"
export * from "./cockpit.vue?vue&type=script&lang=js"
import style0 from "./cockpit.vue?vue&type=style&index=0&id=53d443bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports